/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/issueCredential.config.json";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { ISSUE_CREDENTIAL } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IIssueCredentialMethods extends IPluginMethodMap {
  getIssueCredential(args: any): Promise<any>;
}

export interface IssueCredentialProps {
  formData: any;
  templateId: string;
  userSelected: any[];
  issueType: "public" | "private";
  emailIssue: boolean;
  walletIssue: boolean;
  evidence?: any;
}

export class IssueCredentialService implements IAgentPlugin {
  readonly methods: IIssueCredentialMethods;

  constructor() {
    this.methods = {
      getIssueCredential: this.getIssueCredential.bind(this),
    };
  }

  async getIssueCredential(args: IssueCredentialProps) {
    console.log(`args in issue credential`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    let _evidence =
      Array.isArray(args?.evidence) &&
      args?.evidence.map((item) => {
        return {
          id: item?.base64,
          evidenceDocument: item?.name,
          evidenceDocumentType: item?.type,
        };
      });

    try {
      if (client) {
        const res = await client.mutate({
          mutation: ISSUE_CREDENTIAL,
          variables: {
            email: args?.userSelected,
            credentialTemplateId: args?.templateId,
            visiblity: config?.visiblity,
            credentialContent: args?.formData,
            sendEmail: args?.emailIssue,
            sendPn: args?.walletIssue,
            evidence: _evidence,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.issueCredential) {
          console.log(`table data`, res);
          return {
            ...res?.data?.issueCredential,
            email: args?.userSelected,
            notification: notification?.issueCredentials,
          };
        }
      }
    } catch (err: any) {
      console.log("error in issue credential", err?.message);
    }
  }
}
